import React, { useState } from "react";

import { Spinner } from "../../../components";

import styles from "./vtrg_video.module.scss";

const VtrgVideo = ({ video, slot }) => {
  const [loading, setLoading] = useState(false);

  const path1 =
    !process.env.NODE_ENV || process.env.NODE_ENV === "development"
      ? `http://localhost:3001/${video.first_video_webm?.url}`
      : video.first_video_webm?.url;

  const path2 =
    !process.env.NODE_ENV || process.env.NODE_ENV === "development"
      ? `http://localhost:3001/${video.first_video.url}`
      : video.first_video.url;

  return (
    <div className={styles.Wrapper}>
      <video
        loop={video.autoplay}
        muted={video.autoplay}
        preload="metadata"
        playsInline={video.autoplay}
        autoPlay={video.autoplay}
        className="vtrg-video"
        onLoadedData={() => {
          setLoading(false);
        }}
        onLoadStart={() => {
          setLoading(true);
        }}
      >
        <source src={path1} />
        <source src={path2} />

        <p>Ваш браузер не поддерживает HTML5 видео.</p>
      </video>

      {loading && (
        <div className={styles.Preloader}>
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default VtrgVideo;
